import { useThemeContext } from "#contexts/ThemeContext";
import { makeStyles } from '@material-ui/core';
import { colors } from '@swyft/ui';

export const useAnswerStyles = (isShowHelperText: boolean) =>
  makeStyles((theme: any) => {
    const { iconButtons, primaryButtonBackground, answerText } = useThemeContext();
    return {
      helperAnswerWrapper: {
        '& .helperIcon': {
          color: colors.grey.DEFAULT,
          [theme.breakpoints.up('xs')]: {
            fontSize: 33
          },
          [theme.breakpoints.up('lg')]: {
            fontSize: 46
          }
        },
        '&:hover > .helperIcon > g': {
          color: iconButtons,
          fill: iconButtons
        }
      },
      answerTextWrapper: {
        height: '50% !important'
      },
      answerText: {
        color: answerText,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: '-webkit-box !important',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.down('md')]: {
          '-webkit-line-clamp': isShowHelperText ? 1 : 2
        }
      },
      smallAnswerText: {
        color: answerText,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: '-webkit-box !important',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical'
      },
      pictureHelper: {
        borderRadius: '0.25rem',
        objectFit: 'cover',
        margin: '0 auto',
        width: 80,
        height: 80,
        [theme.breakpoints.down('md')]: {
          width: 48,
          height: 48
        }
      },
      helperAnswerText: {
        opacity: isShowHelperText ? 1 : 0
      },
      checkbox: {
        '&.MuiCheckbox-colorPrimary.Mui-checked': {
          '& .MuiSvgIcon-root': {
            backgroundColor: primaryButtonBackground,
            width: 18,
            height: 18,
            borderRadius: 3
          },
          color: colors.white,
          width: 44,
          height: 24,
          '&:hover': {
            color: colors.white
          }
        },
        '&.MuiCheckbox-colorPrimary:hover': {
          color: primaryButtonBackground
        }
      }
    };
  });
